module.exports = __webpack_public_path__ + "img/utilityheavy_driving.430f8a37.svg";